/*! Copyright [Amazon.com](http://amazon.com/), Inc. or its affiliates. All Rights Reserved.
SPDX-License-Identifier: Apache-2.0 */
import React from "react";
import { DefaultApiClientProvider as VenueLoyaltyAPIApiClientProvider } from "venue-loyalty-api-typescript-react-query-hooks";
import { useVenueLoyaltyAPIApiClient } from "../../hooks/useTypeSafeApiClient";

/**
 * Sets up the Type Safe Api clients.
 */
const TypeSafeApiClientProvider: React.FC<any> = ({ children }) => {
  const VenueLoyaltyAPIClient = useVenueLoyaltyAPIApiClient();

  return (
    <VenueLoyaltyAPIApiClientProvider apiClient={VenueLoyaltyAPIClient!}>
      {children}
    </VenueLoyaltyAPIApiClientProvider>
  );
};

export default TypeSafeApiClientProvider;
